import { useQuery } from "@apollo/client";
import { Accessor } from "mt-components";
import { gql } from "../../__generated__";
import capitalizeFirstLetter from "../../helpers/capitalize-first-letter";
import Select from "../Select";

const ALL_CITIES = "allCities";

type CitySelectorProps = Accessor<string, "city"> & {
  countryId: string | null;
};

export default function CitySelector(props: CitySelectorProps) {
  const { data } = useQuery(GET_CITIES, {
    variables: { countryId: props.countryId },
  });
  const cities =
    data?.locations.records.map((location) => ({
      id: location.id,
      name: capitalizeFirstLetter(location.slug),
    })) || [];

  return (
    <Select<string>
      sx={{ backgroundColor: "white", width: "140px" }}
      size="small"
      label="City"
      hideNone
      value={props.city || ALL_CITIES}
      options={[{ id: ALL_CITIES, name: "All cities" }, ...cities]}
      onChange={(city) => props.setCity(city === ALL_CITIES ? "" : city)}
    />
  );
}

const GET_CITIES = gql(`
  query GetCities($countryId: ID) {
    locations(input: { countryId: $countryId, locationType: [PREFECTURE, CITY], hasPublishedProducts: true }) {
      records {
        id
        slug
      }
    }
  }
`);
